import {CanActivateFn} from '@angular/router';
import {inject} from '@angular/core';
import {JwtService} from '../../services/infrastructure/auth/jwt/jwt.service';

export const authGuard: CanActivateFn = () => {
  const jwtService = inject(JwtService);
  return jwtService.hasAccessToken();
};
